import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export const getChatId = async (user1, user2) => {
  if (!user1 || !user2) return null;

  const idA = `${user1}_${user2}`;
  const idB = `${user2}_${user1}`;

  // 1. Check if ID Format A exists
  const refA = doc(db, "chats", idA);
  const snapA = await getDoc(refA);
  if (snapA.exists()) {
    return idA; // Return existing ID
  }

  // 2. Check if ID Format B exists
  const refB = doc(db, "chats", idB);
  const snapB = await getDoc(refB);
  if (snapB.exists()) {
    return idB; // Return existing ID
  }

  // 3. If NO ID exists, create a NEW stable ID
  // We sort them so that (User1, User2) and (User2, User1) 
  // always generate the same string regardless of who clicks first.
  const finalId = user1 < user2 ? idA : idB;

  try {
    await setDoc(doc(db, "chats", finalId), {
      users: [user1, user2],
      createdAt: String(Date.now()),
      lastMessage: "",
      lastMessageTime: String(Date.now()),
      lastFrom: "",
      lastTo: ""
    });
    
    return finalId;
  } catch (error) {
    console.error("Error creating chat ID:", error);
    return finalId; // Return the ID anyway so the app doesn't crash
  }
};

export const annualIncomeMap = (income) => {
  const map = {
    "0-100000": "Upto 1 Lakh",
    "100000-200000": "1 Lakh - 2 Lakh",
    "200000-400000": "2 Lakh - 4 Lakh",
    "400000-700000": "4 Lakh - 7 Lakh",
    "700000-1000000": "7 Lakh - 10 Lakh",
    "1000000-1500000": "10 Lakh - 15 Lakh",
    "1500000-2000000": "15 Lakh - 20 Lakh",
    "2000000-3000000": "20 Lakh - 30 Lakh",
    "3000000-5000000": "30 Lakh - 50 Lakh",
    "5000000-7500000": "50 Lakh - 75 Lakh",
    "7500000-10000000": "75 Lakh - 1 Crore",
    "10000000-30000000": "1 Crore - 3 Crore",
    "30000000-50000000": "3 Crore - 5 Crore",
    "Above 50000000": "Above 5 Crore",
    "Not Applicable": "Not Applicable",
  };

  return map[income] || "";
};


export const incomeRangeMap = {
  "100000": "1 Lakh",
  "200000": "2 Lakh",
  "300000": "3 Lakh",
  "400000": "4 Lakh",
  "500000": "5 Lakh",
  "700000": "7 Lakh",
  "1000000": "10 Lakh",
  "1500000": "15 Lakh",
  "2000000": "20 Lakh",
  "2500000": "25 Lakh",
  "3500000": "35 Lakh",
  "5000000": "50 Lakh",
  "7000000": "70 Lakh",
  "10000000": "1 Crore",
  "Above 10000000": "Above 1 Crore"
};

